import { render, staticRenderFns } from "./DetailInbound.vue?vue&type=template&id=1a168e1a&scoped=true&"
import script from "./DetailInbound.vue?vue&type=script&lang=js&"
export * from "./DetailInbound.vue?vue&type=script&lang=js&"
import style0 from "./DetailInbound.vue?vue&type=style&index=0&id=1a168e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a168e1a",
  null
  
)

export default component.exports